export enum StatusTypeEnum {
  ACTIVE,
  PASSIVE,
  NOT_RELEVANT,
  NOT_PRESENT,
}

export const allStatusTypes = () => {
  return [
    StatusTypeEnum.ACTIVE,
    StatusTypeEnum.PASSIVE,
    StatusTypeEnum.NOT_RELEVANT,
    StatusTypeEnum.NOT_PRESENT,
  ];
};

export const mapStringToStatusEnum = (value: String): StatusTypeEnum => {
  switch (value && value.toUpperCase()) {
    case "ACTIVE":
      return StatusTypeEnum.ACTIVE;
    case "PASSIVE":
      return StatusTypeEnum.PASSIVE;
    case "NOT_PRESENT":
      return StatusTypeEnum.NOT_PRESENT;
    case "NOT_RELEVANT":
      return StatusTypeEnum.NOT_RELEVANT;
    default:
      return StatusTypeEnum.ACTIVE;
  }
};

export const translateKey = (value: string): string => {
  return "statusType." + value.toLowerCase();
};
